import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { Box, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';

const Search = ({
  projects,
  setIsSearching,
  isSearching,
  setSearchedProjects,
}: {
  projects: Project[];
  isSearching: boolean;
  setIsSearching: SetIsSearching;
  setSearchedProjects: SetSearchedProjects;
}) => {
  const [inputValue, setInputValue] = useState('');

  const handleSearch = (query: string) => {
    const inputQuery = query.toLocaleLowerCase();
    const filteredProjects = projects.filter((project) => {
      const title = project.title.toLocaleLowerCase();
      const providers = project.providers.map((provider) =>
        provider.toLocaleLowerCase(),
      );
      const tags = project.tags.map((tag) => tag.toLocaleLowerCase());

      return (
        tags.some((tag) => tag.includes(inputQuery)) ||
        title.includes(inputQuery) ||
        providers.some((provider) => provider.includes(inputQuery))
      );
    });
    setSearchedProjects(filteredProjects);
  };

  useEffect(() => {
    if (inputValue) {
      handleSearch(inputValue);
      setIsSearching(true);
    } else {
      setSearchedProjects([]);
      setIsSearching(false);
    }
  }, [inputValue]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setInputValue('');
        setIsSearching(false);
        setSearchedProjects([]);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
      <SearchIcon
        classes={{
          root: 'navbar-search-icon',
        }}
        sx={{ mr: 1, my: 0.5 }}
      />
      <TextField
        InputProps={{
          className: 'navbar-search-input',
          disableUnderline: true,
        }}
        InputLabelProps={{
          className: 'navbar-search-label',
          shrink: false,
        }}
        label={inputValue ? '' : 'Search'}
        variant="standard"
        value={inputValue}
        onChange={(event) => setInputValue(event.target.value)}
      />
      {isSearching && (
        <CloseIcon
          classes={{
            root: 'navbar-search-close',
          }}
          onClick={() => {
            setInputValue('');
            setIsSearching(false);
            setSearchedProjects([]);
          }}
        />
      )}
    </Box>
  );
};

export default Search;
